import clsx from 'clsx';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import { useSidebarLayout } from 'providers/root/SidebarLayoutProvider';

import { useViewPanelLayoutStyles } from '../styles';
import { TopBarProps } from '../types';

/**
 * TopBar component for ViewPanelLayout
 *
 * Provides a sticky app bar with toolbar styling that adapts to sidebar layout state.
 * Used to contain navigation elements, titles, and action buttons within ViewPanelLayout.
 *
 * @param props - Component properties
 * @param props.children - Content to render inside the toolbar
 * @returns JSX.Element TopBar component
 *
 * @example
 * <TopBar>
 *   <ButtonNavigationBack onClick={handleBack}>
 *     Go Back
 *   </ButtonNavigationBack>
 *   <Title>Page Title</Title>
 * </TopBar>
 */
const TopBar = ({ children }: TopBarProps): JSX.Element => {
  const { openMdDrawer } = useSidebarLayout();
  const classes = useViewPanelLayoutStyles({ open: openMdDrawer });

  return (
    <AppBar className={clsx(classes.appBar)} elevation={0} position="sticky">
      <Toolbar className={clsx(classes.toolbar)}>{children}</Toolbar>
    </AppBar>
  );
};

export default TopBar;
